import {createElement} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {innerHTMLText} from '@freckle/educator-entities/ts/common/models/html-text'
import type {HeadingProps} from '@freckle/educator-materials/ts/components/typography/heading-props'
import {h3} from './typography.module.scss'

type Props = HeadingProps

export function H3(props: Props) {
  const {children, id, className, dataTest} = props
  const newClassName = addMaybeClassName(h3, className)
  const dataTestObj = dataTest !== null && dataTest !== undefined ? {'data-test': dataTest} : {}
  const tagToUse = props.as ?? 'h3'
  const node = createElement(
    tagToUse,
    {
      className: newClassName,
      ...dataTestObj,
      id,
      ...(props.innerHTMLText !== undefined ? innerHTMLText(props.innerHTMLText) : {})
    },
    children
  )
  return node
}
